module.exports = __webpack_public_path__ + "img/1.32ae3fa6.png";